import React, { Component } from 'react'
import { Spin, Button, Table, Layout, Icon, Input, Calendar, Row, Col, Radio, Modal, Switch, message } from 'antd'
import { Link } from 'react-router-dom'
import {travelList, travelStatusCont, travelDetail, createTravel,travelUp} from '_src/api/api'
import moment from 'moment'
const { Search } = Input

function getTypeName (type) {
  switch (type) {
  case 1:
    return '省内游'
  case 2:
    return '国内游'
  case 3:
    return '出境短游'
  case 4:
    return '出境长游'
  default:
    return '未知'
  }
}

class GoodType extends Component {
  constructor (props) {
    super(props)


    // 3个月区间
    let newDate = new Date()
    newDate.setMonth((newDate.getMonth())+3)

    this.state = {
      isLoading: false,

      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment(newDate).format('YYYY-MM-DD'),

      createModelVisible: false,
      
      statusArr: [],

      params: {
        pageNum: 0,
        pageSize: 10,
      },

      pageData: {
        total: 0, 
        current: 1, 
      },

      list: [],

      columns: [
        {
          title: <span>线路ID</span>,
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: <span>线路名称</span>,
          align: 'center',
          dataIndex: 'travelName',
          key: 'travelName',
          width: 450,
        },
        {
          title: <span>出游类型</span>,
          align: 'center',
          dataIndex: 'travelType',
          render: item => getTypeName(item)
        },
        {
          title: <span>合作方</span>,
          align: 'center',
          dataIndex: 'partner',
        },
        {
          title: <span>时间/价格</span>,
          align: 'center',
          render: item => <Button icon="calendar" onClick={() => { this.lookTimer(item) }}>查看</Button>
        },
        {
          title: <span>创建时间</span>,
          align: 'center',
          dataIndex: 'createAt',
        },
        {
          title: <span>线路状态</span>,
          align: 'center',
          dataIndex: 'status',
          render: item => <div>{item === 0 ? <Icon type="check-circle" theme="twoTone" style={{color: 'green', fontSize: 20}} /> : <Icon type="close-circle" theme="filled" style={{color: '#ccc', fontSize: 18}} /> }</div>
        },
        {
          title: <span>操作</span>,
          align: 'center',
          width: 300,
          render: item => <div>
            <Link to={{ pathname: '/trip/travelDetail?id=' + item.id }} target="_blank" style={{marginRight: 10}}><Button type="primary" icon="eye">查看</Button></Link>
            <Link to={{ pathname: '/trip/editTravel?id=' + item.id }} target="_blank"><Button icon="edit" style={{marginRight: 10}}>修改</Button></Link>
            <Switch checked={item.status === 0} checkedChildren="上架" unCheckedChildren="下架" onClick={()=> this.changeStatus(item)} /> 
          </div>,
        },
      ]
    }
  }

  componentDidMount () {
    const {params} = this.state
    this.loadList(params)

    // 状态统计
    travelStatusCont()
      .then(res => {
        const list = res.data
        const allStatus = list.filter(item => item.status === '总数')[0]
        const takeStatus = list.filter(item => item.status === '0')[0]
        const closeStatus = list.filter(item => item.status === '1')[0]
        this.setState({
          allStatus,
          takeStatus,
          closeStatus,
        })
      })
  }

  loadList (params) {
    this.setState({isLoading: true})
    travelList(params)
      .then(res => {
        this.setState({
          list: res.data.content,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
            total: 0,
            pageSize: 0,
          },
        })
      })
  }

  // 上下架编辑
  changeStatus = (item) => {
    const {id,status} = item
    const {params} = this.state
    if(status===0 || status===1){
      const _this = this
      const title = status === 0 ? '下架提醒' : '上架提醒'
      const content = status === 0 ? '确定要下架这个专线？' : '确定要上架这个专线？'
      Modal.confirm({
        title,
        content,
        onOk () {
          const hide = message.loading('数据提交中...')
          const statusParam = status ===0?1:0
          travelUp(id,statusParam).then(() => {
            hide()
            _this.loadList(params)
          })
          .catch(() => {
            hide()
            message.error('请求超时，请稍后再试')
          })
        },
        onCancel () {
          //
        },
      })
    }
   
  }

  // 分页
  onPageChange = (e) => {
    const {params} = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }

  // 搜索
  searchName = (value) => {
    const {params} = this.state
    if (value) {
      params.travelName = value
    } else {
      delete params.travelName
    }
    params.pageNum = 0
    this.loadList(params)
  }

  // 状态切换
  statusChange = (e) => {
    const value = e.target.value
    const {params} = this.state
    if (typeof value === 'number') {
      params.status = value
    } else {
      delete params.status
    }
    params.pageNum = 0
    this.loadList(params)
  }

  // 查看 
  lookTimer = (item) => {
    travelDetail({id: item.id})
      .then(res => {
        this.setState({
          travelDates: res.data.dates,
          visible: true,
          selectInfo: item,
        })
      })
  }

  // 日历时间可选判断
  disabledDate = (item) => {
    const {startDate, endDate} = this.state
    item = moment(item).format('YYYY-MM-DD')
    return item < startDate || item > endDate
  }
  // 日历单元格渲染
  dateCellRender = (item) => {
    const {startDate, endDate, travelDates} = this.state
    item = moment(item).format('YYYY-MM-DD')
    // 不可设置内容区域
    if (item < startDate || item > endDate) {
      return <div className='data-after-content flex-a'>/</div>
    } 
    const curObj = travelDates.filter(ele => ele.date === item)[0]
    if (curObj) {
      return (
        <div className='data-after-content'>
          <div><span style={{fontSize: 12}}>票数：</span>{curObj.tickets || 0}张</div>
          <div className='price'><span style={{fontSize: 12}}>售价：</span>{(curObj.salePrice / 100).toFixed(2)}</div>
          <div className='price-default'><span style={{fontSize: 12}}>原价：</span>{(curObj.costPrice / 100).toFixed(2)}</div>
        </div>
      )
    }
    return <div className='data-after-content not-content flex-a'>未设置</div>
  }
  
  render () {
    const {
      selectInfo,
      visible,
      isLoading, 
      list,
      columns, 
      pageData, 
      allStatus,
      takeStatus,
      closeStatus,
    } = this.state
    return (
      <Layout className="goodType-page" style={{ padding: 20, backgroundColor: 'white' }}>
        {this.state.isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <Row style={{ paddingBottom: 20 }}>
          <Col lg={{ span: 8 }} style={{width: 180, borderRight: '1px solid #ccc', marginRight: 40}} className="flex-h-a">
            <Link to={{ pathname: '/trip/editTravel'}} target="_blank" >
              <Button className='creat-station' type="primary" icon="plus" style={{ width: 150 }}>新增旅游专线</Button>
            </Link>
          </Col>
          <Col lg={{ span: 8 }} style={{width: 420}} className="flex-h-a">
            <Radio.Group defaultValue="" buttonStyle="outline" onChange={this.statusChange}>
              <Radio.Button value=''>全部路线（{allStatus ? allStatus.count : 0}）</Radio.Button>
              <Radio.Button value={0}>生效中（{takeStatus ? takeStatus.count : 0}）</Radio.Button>
              <Radio.Button value={1}>已失效（{closeStatus ? closeStatus.count : 0}）</Radio.Button>
            </Radio.Group>
          </Col>
          <Col lg={{ span: 8 }} className="flex-h-a">
            <span>线路名称：</span>
            <Search style={{ width: 220 }} placeholder="线路名称搜索" onSearch={this.searchName} enterButton />
          </Col>
        </Row>
        {
          !isLoading && (
            <Table
              columns={columns}
              dataSource={list}
              bordered
              rowKey="id"
              pagination={{
                current: pageData.current,
                total: pageData.total,
                pageSize: pageData.pageSize,
              }}
              onChange={this.onPageChange}
            />
          )
        }
        <Modal
          title={`查看专线价格：（ 路线：${selectInfo ? selectInfo.travelName: ''} ）`}
          visible={visible}
          onCancel={()=>this.setState({visible: false})}
          width={1300}
          footer={false}
          destroyOnClose
        >
          <div className='Calendar-inner' style={{width: '100%'}}>
            <Calendar
              onSelect={this.onDateSelect}
              disabledDate={this.disabledDate}
              dateCellRender={this.dateCellRender}
            />
          </div>
        </Modal>
      </Layout>
    )
  }
}

export default GoodType